const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

export const getVacancyApplicationTypeViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Info'),
      fields: [{ text: t('Titolo'), value: display(item.title) }],
    },
  ];
};
